import { Preferences } from '@capacitor/preferences';

export class CapacitorOktaStorage {
  private cache: Record<string, string> = {};

  constructor() {
    this.loadExisting();
  }

  private async loadExisting() {
    // preload only known Okta keys safely (NOT all keys)
    const knownKeys = [
      'okta-token-storage',
      'okta-cache-storage',
      'okta-state-storage',
      'okta-pkce-storage'
    ];

    for (const key of knownKeys) {
      const { value } = await Preferences.get({ key });
      if (value) {
        this.cache[key] = value;
      }
    }
  }

  getItem(key: string): string | null {
    return this.cache[key] ?? null;
  }

  setItem(key: string, value: string): void {
    this.cache[key] = value;
    Preferences.set({ key, value });
  }

  removeItem(key: string): void {
    delete this.cache[key];
    Preferences.remove({ key });
  }
}